export type ReferralFilterParams = {
    counties: string[];
    serviceType: string[];
    serviceLocation: string[];
    placementType: string[]
    serviceLocationType: string[]
};

export type ReferralFilterState = {
    serviceTypes: string[];
    cities: string[];
    counties: string[];
    zipcodes: string[];
    scopeOfServices: string[];
    serviceLocationTypes: string[];
}

export function toGraphQlParams(state: ReferralFilterState): ReferralFilterParams {
    return {
        serviceType: state.serviceTypes,
        counties: state.counties,
        serviceLocation: [...new Set([
            ...state.cities,
            ...state.zipcodes,
        ])],
        placementType: state.scopeOfServices,
        serviceLocationType: state.serviceLocationTypes,
    };
}

